export default "__VITE_ASSET__7f23b03e__"